import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ParamFilters } from "@app/models/filtermodels/ParamFilters";
import { ActivatedRoute, Router } from "@angular/router";
import { EncryptionService } from "./encyption.service";
import { isPlatformBrowser, Location } from "@angular/common";
import moment from "moment";
import { CombiOptionListItem } from "@app/models/hotels/CombiOptionListItem";
import { AuthGuardService } from "./auth-guard.service";

@Injectable({
    providedIn: "root",
})
export class HotelFiltersService {
    protected filters: BehaviorSubject<ParamFilters>;
    protected extrasCount: BehaviorSubject<number>;
    protected realparams: ParamFilters = {} as ParamFilters;
    protected openHotelInfoWithOperator: BehaviorSubject<string>;
    protected openPreisAlarmModal: BehaviorSubject<boolean>;
    protected preisAlarm: BehaviorSubject<boolean>;
    protected subCombiOptionListItem: BehaviorSubject<CombiOptionListItem>;

    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        protected encservice: EncryptionService,
        protected location: Location,
        protected guardService: AuthGuardService,
        @Inject(PLATFORM_ID) protected platformId: any
    ) {
        this.filters = new BehaviorSubject(null);
        this.extrasCount = new BehaviorSubject(0);
        this.openPreisAlarmModal = new BehaviorSubject(false);
        this.preisAlarm = new BehaviorSubject(false);
        this.openHotelInfoWithOperator = new BehaviorSubject(null);
        this.subCombiOptionListItem = new BehaviorSubject(null);
        if (isPlatformBrowser(this.platformId)) {
            setTimeout(() => {
                this.initFilters();
            }, 50);
        }
    }

    private showSearchSubject = new BehaviorSubject<boolean>(false);

    get openPreisAlarmModal$(): Observable<boolean> {
        return this.openPreisAlarmModal.asObservable();
    }

    get preisAlarm$(): Observable<boolean> {
        return this.preisAlarm.asObservable();
    }

    get getfilters$(): Observable<ParamFilters> {
        return this.filters?.asObservable();
    }

    get openHotelInfoWithOperator$() {
        return this.openHotelInfoWithOperator.asObservable();
    }

    get subCombiOptionListItem$() {
        return this.subCombiOptionListItem.asObservable() as Observable<CombiOptionListItem>;
    }

    setCombiOptionListItem$(value: CombiOptionListItem) {
        this.subCombiOptionListItem.next(value);
    }

    setOpenPreisAlarmModal$(value: boolean) {
        this.openPreisAlarmModal.next(value);
    }

    setpreisAlarm$(value: boolean) {
        this.preisAlarm.next(value);
    }

    initFilters() {
        if (
            this.route.snapshot.queryParams["params"] &&
            this.route.snapshot.queryParams["params"].length > 0
        ) {
            const tokenFromUI = this.route.snapshot.queryParams["params"]?.slice(-16);
            const data = this.route.snapshot.queryParams["params"]?.slice(
                0,
                this.route.snapshot.queryParams["params"].length - 16
            );
            this.realparams = JSON.parse(
                this.encservice.deencrypt(tokenFromUI, data)
            );
            this.realparams.productType =
                this.realparams.productType?.length > 0
                    ? this.realparams.productType
                    : "pauschal";
            this.realparams.israiltravel =
                this.realparams.productType === "railtravel";
            this.realparams = this.checkDate(this.realparams);
            if (Number(this.realparams.minCategory) >= 0) {
                this.realparams.minCategory = Number(this.realparams.minCategory);
            } else {
                this.realparams.minCategory = 0;
            }
            this.filters.next(this.realparams);
        } else {
            if (!this.realparams?.productType) {
                this.setDefault();
            }
        }
    }

    checkDate(params: ParamFilters): ParamFilters {
        if (params.reisezeitraumResult) {
            if (!params?.reisedauerResult) {
                if (
                    params.reisezeitraumResult?.minDuration &&
                    params.reisezeitraumResult?.minDuration ===
                    params.reisezeitraumResult?.maxDuration
                ) {
                    if (params.reisezeitraumResult?.minDuration === "-1") {
                        params.reisedauerResult = {
                            name: "exakt wie angegeben",
                            minDuration: "-1",
                            maxDuration: "-1",
                        };
                    } else {
                        params.reisedauerResult = {
                            name: params.reisezeitraumResult?.minDuration + " Tage",
                            minDuration: params.reisezeitraumResult?.minDuration,
                            maxDuration: params.reisezeitraumResult?.maxDuration,
                        };
                    }
                } else {
                    if (Number(params.reisezeitraumResult?.maxDuration) > 0) {
                        params.reisedauerResult = {
                            name:
                                params.reisezeitraumResult?.minDuration +
                                " - " +
                                params.reisezeitraumResult?.maxDuration +
                                " Tage",
                            minDuration: params.reisezeitraumResult?.minDuration,
                            maxDuration: params.reisezeitraumResult?.maxDuration,
                        };
                    } else if (Number(params.reisezeitraumResult?.minDuration) > 0) {
                        params.reisedauerResult = {
                            name: params.reisezeitraumResult?.minDuration + " Tage",
                            minDuration: params.reisezeitraumResult?.minDuration,
                            maxDuration: "17",
                        };
                    } else {
                        const reg = new RegExp("^\\d+,\\d+,\\d+$");
                        if (String(params.reisezeitraumResult).match(reg)) {
                            const tmp = String(params.reisezeitraumResult).split(",");
                            params.reisedauerResult = {
                                name: tmp[2] + " - 17 Tage",
                                minDuration: tmp[2],
                                maxDuration: "17",
                            };
                            params.reisezeitraumResult = {
                                start: moment().add(tmp[0], "days").format("YYYY-MM-DD"),
                                end: moment()
                                    .add(Number(tmp[1]) + Number(tmp[0]), "days")
                                    .format("YYYY-MM-DD"),
                                minDuration: tmp[2],
                                maxDuration: "17",
                            };
                        }
                    }
                }
            }
            const reg = new RegExp("^\\d+,\\d+,\\d+$");
            if (String(params.reisezeitraumResult).match(reg)) {
                const tmp = String(params.reisezeitraumResult).split(",");
                params.reisedauerResult = {
                    name: tmp[2] + " - 17 Tage",
                    minDuration: tmp[2],
                    maxDuration: "17",
                };
                params.reisezeitraumResult = {
                    start: moment().add(tmp[0], "days").format("YYYY-MM-DD"),
                    end: moment()
                        .add(Number(tmp[1]) + Number(tmp[0]), "days")
                        .format("YYYY-MM-DD"),
                    minDuration: tmp[2],
                    maxDuration: "17",
                };
            } else if (!isNaN(Number(params?.reisezeitraumResult?.start))) {
                params.reisezeitraumResult.start = moment()
                    .add(Number(params.reisezeitraumResult.start), "days")
                    .format("YYYY-MM-DD");
                params.reisezeitraumResult.end = moment()
                    .add(Number(params.reisezeitraumResult.end), "days")
                    .format("YYYY-MM-DD");
            } else if (Number(params.reiseMonth) >= 0) {
                let year = moment().year();
                let start = "";
                let end = "";
                if (moment().month() > Number(params.reiseMonth)) {
                    year += 1;
                    start = moment()
                        .set({ date: 1, month: Number(params.reiseMonth), year: year })
                        .format("YYYY-MM-DD");
                    end = moment(start).add(60, "days").format("YYYY-MM-DD");
                } else if (moment().month() === Number(params.reiseMonth)) {
                    start = moment().format("YYYY-MM-DD");
                    end = moment(start).add(60, "days").format("YYYY-MM-DD");
                } else {
                    start = moment()
                        .set({ date: 1, month: Number(params.reiseMonth), year: year })
                        .format("YYYY-MM-DD");
                    end = moment(start).add(60, "days").format("YYYY-MM-DD");
                }
                params.reisezeitraumResult.start = start;
                params.reisezeitraumResult.end = end;
            } else {
                params.reisezeitraumResult.start = moment(
                    params.reisezeitraumResult.start
                ).format("YYYY-MM-DD");
                params.reisezeitraumResult.end = moment(
                    params.reisezeitraumResult.end
                ).format("YYYY-MM-DD");
            }

            if (
                moment(params?.reisezeitraumResult?.start).format("YYYY-MM-DD") <
                moment().format("YYYY-MM-DD")
            ) {
                if (
                    moment(params?.reisezeitraumResult?.start).month() ===
                    moment().month()
                ) {
                    params.reisezeitraumResult.start = moment()
                        .add(3, "days")
                        .format("YYYY-MM-DD");
                } else {
                    params.reisezeitraumResult.start = moment()
                        .add(3, "days")
                        .format("YYYY-MM-DD");
                }
            }
            if (
                moment(params?.reisezeitraumResult?.end).format("YYYY-MM-DD") <
                moment().format("YYYY-MM-DD")
            ) {
                if (
                    moment(params?.reisezeitraumResult?.end).month() === moment().month()
                ) {
                    params.reisezeitraumResult.end = moment(
                        params.reisezeitraumResult.start
                    )
                        .add(180, "days")
                        .format("YYYY-MM-DD");
                } else {
                    params.reisezeitraumResult.end = moment(
                        params.reisezeitraumResult.start
                    )
                        .add(180, "days")
                        .format("YYYY-MM-DD");
                }
            }

            if (
                params.reisezeitraumResult?.minDuration !== "-1" &&
                moment(params?.reisezeitraumResult?.end).format("YYYY-MM-DD") <
                moment(params.reisezeitraumResult.start)
                    .add(params.reisezeitraumResult?.minDuration, "days")
                    .format("YYYY-MM-DD")
            ) {
                params.reisezeitraumResult.end = moment(
                    params.reisezeitraumResult.start
                )
                    .add(params.reisezeitraumResult?.minDuration, "days")
                    .format("YYYY-MM-DD");
            }
        } else {
            params.reisedauerResult = {
                name: "3 - 17 Tage",
                minDuration: "3",
                maxDuration: "17",
            };
            params.reisezeitraumResult = {
                minDuration: "3",
                maxDuration: "17",
                start: moment().add(7, "days").format("YYYY-MM-DD"),
                end: moment().add(180, "days").format("YYYY-MM-DD"),
            };
        }
        return params;
    }

    setRealParams(params) {
        this.realparams = JSON.parse(JSON.stringify(params));
        this.realparams = this.checkDate(this.realparams);
        if (Number(this.realparams.minCategory) >= 0) {
            this.realparams.minCategory = Number(this.realparams.minCategory);
        } else {
            this.realparams.minCategory = 0;
        }
        this.filters.next(this.realparams);
        this.changeUrl();
    }

    onlySetRealParams(params) {
        this.realparams = JSON.parse(JSON.stringify(params));
        this.realparams = this.checkDate(this.realparams);
        if (Number(this.realparams.minCategory) >= 0) {
            this.realparams.minCategory = Number(this.realparams.minCategory);
        } else {
            this.realparams.minCategory = 0;
        }
        this.filters.next(this.realparams);
    }

    setDefault() {
        this.realparams = {} as ParamFilters;
        this.realparams.productType = "pauschal";
        if (Number(this.realparams.minCategory) >= 0) {
            this.realparams.minCategory = Number(this.realparams.minCategory);
        } else {
            this.realparams.minCategory = 0;
        }
        this.realparams.reisezeitraumResult = {
            start: moment().add(4, "days").format("YYYY-MM-DD"),
            end: moment().add(180, "days").format("YYYY-MM-DD"),
            minDuration: 7,
            maxDuration: 7,
        };

        this.realparams.reisendeResult = {
            adults: 2,
            children: [],
        };

        this.realparams.reisedauerResult = {
            name: "1 Woche",
            minDuration: "7",
            maxDuration: "7",
        };
        this.filters.next(this.realparams);
    }

    setonlyDefault() {
        this.realparams = {} as ParamFilters;
        this.realparams.productType = "pauschal";
        this.realparams.reisezeitraumResult = {
            start: moment().add(4, "days").format("YYYY-MM-DD"),
            end: moment().add(180, "days").format("YYYY-MM-DD"),
            minDuration: 7,
            maxDuration: 7,
        };

        this.realparams.reisendeResult = {
            adults: 2,
            children: [],
        };

        this.realparams.reisedauerResult = {
            name: "1 Woche",
            minDuration: "7",
            maxDuration: "7",
        };
    }

    pauschalreiseResult(value) {
        this.realparams.provider = value?.peakwork ? "peakwork" : "";
        this.realparams.giataIdList = null;
        this.realparams.arrivalAirportList = null;
        this.realparams.hotelCodeList = null;
        this.realparams.extra = null;
        this.realparams.bookingcode = null;
        this.realparams.pauschalreiseResult = value;
    }

    reisedauerResult(value) {
        this.realparams.reisedauerResult = value;
        if (this.realparams.reisezeitraumResult) {
            this.realparams.reisezeitraumResult.minDuration = value.minDuration;
            this.realparams.reisezeitraumResult.maxDuration = value.maxDuration;
        } else {
            this.realparams.reisezeitraumResult = {
                minDuration: value.minDuration,
                maxDuration: value.maxDuration,
                start: moment().add(7, "days").format("YYYY-MM-DD"),
                end: moment().add(180, "days").format("YYYY-MM-DD"),
            };
        }
    }

    reisendeResult(value) {
        this.realparams.reisendeResult = value;
    }

    airportsResult(value, ifchangeUrl) {
        this.realparams.airportsResult = value;
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    arrivalAirports(value, ifchangeUrl) {
        this.realparams.arrivalAirportList = value;
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    reisezeitraumResult(start, end) {
        if (this.realparams.reisezeitraumResult) {
            this.realparams.reisezeitraumResult.start = start;
            this.realparams.reisezeitraumResult.end = end;

            const difday = moment(end).diff(moment(start), "days");

            if (Number(this.realparams.reisedauerResult.minDuration) > difday) {
                this.realparams.reisedauerResult.minDuration = difday;
                this.realparams.reisezeitraumResult.minDuration = difday;
            }
        } else {
            this.realparams.reisezeitraumResult = {
                minDuration: "7",
                maxDuration: "7",
                start: start,
                end: end,
            };
        }

        this.filters.next(this.realparams);
    }

    price(value, ifchangeUrl) {
        this.realparams.minPricePerPerson = value.min;
        this.realparams.maxPricePerPerson = value.max;
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    recommendation(value, ifchangeUrl) {
        this.realparams.recommendation = value;
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    recommendationcount(value, ifchangeUrl) {
        this.realparams.recommendationcount = value;
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    inclusiveListServiceOffer(value) {
        this.realparams.inclusiveListServiceOffer = value;
        this.changeUrl();
    }

    onlySetProductType(value) {
        this.realparams.productType = value;
        this.filters.next(this.realparams);
    }

    setProductType(value) {
        this.realparams.productType = value;
        this.changeUrl();
    }

    category(value, ifchangeUrl) {
        this.realparams.minCategory = value;
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    meerseite(value, ifchangeUrl) {
        this.realparams.meerseite = value;
        this.locatedList({ name: "Seeblick", code: "ms" }, false, ifchangeUrl);
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    zommermitmeerblick(value, ifchangeUrl) {
        this.realparams.zommermitmeerblick = value;
        this.locatedList({ name: "Meerblick", code: "mb" }, false, ifchangeUrl);
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    departureTime(value, ifchangeUrl) {
        this.realparams.maxdepartureTime = value?.max;
        this.realparams.mindepartureTime = value?.min;
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    returnTime(value, ifchangeUrl) {
        this.realparams.maxreturnTime = value?.max;
        this.realparams.minreturnTime = value?.min;
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    arrivalAirportList(value, ifchangeUrl) {
        if (
            JSON.stringify(this.realparams.arrivalAirportList) !==
            JSON.stringify(value)
        ) {
            this.realparams.arrivalAirportList = value;
            if (ifchangeUrl) {
                this.changeUrl();
            }
        }
    }

    departurAirportList(value, ifchangeUrl) {
        if (
            JSON.stringify(this.realparams.airportsResult) !== JSON.stringify(value)
        ) {
            this.realparams.airportsResult = value;
            if (ifchangeUrl) {
                this.changeUrl();
            }
        }
    }

    hotelChainList(value) {
        if (
            JSON.stringify(this.realparams.hotelChainList) !== JSON.stringify(value)
        ) {
            this.realparams.hotelChainList = value;
            this.changeUrl();
        }
    }

    flightCarrierList(value) {
        if (
            JSON.stringify(this.realparams.flightCarrierList) !==
            JSON.stringify(value)
        ) {
            this.realparams.flightCarrierList = value;
            this.changeUrl();
        }
    }

    boardTypeList(value, push, ifchangeUrl) {
        if (!this.realparams.boardTypeList) {
            this.realparams.boardTypeList = [];
        }

        if (push) {
            if (!this.realparams.boardTypeList.some((i) => i.name == value.name)) {
                this.realparams.boardTypeList.push(value);
            }
        } else {
            const index = this.realparams.boardTypeList.findIndex((item, i) => {
                return item.code === value.code;
            });
            if (index >= 0) {
                this.realparams.boardTypeList.splice(index, 1);
            }
        }

        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    transferlist(value, push, ifchangeUrl) {
        if (!this.realparams.transferlist) {
            this.realparams.transferlist = [];
        }

        if (push) {
            this.realparams.transferlist.push(value);
        } else {
            const index = this.realparams.transferlist?.indexOf(value);
            if (index >= 0) {
                this.realparams.transferlist.splice(index, 1);
            }
        }
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    inclusiveList(value, push, ifchangeUrl) {
        if (!this.realparams.inclusiveList) {
            this.realparams.inclusiveList = [];
        }
        if (push) {
            this.realparams.inclusiveList.push(value);
        } else {
            const index = this.realparams.inclusiveList.findIndex((item, i) => {
                return item.code === value.code;
            });
            if (index >= 0) {
                this.realparams.inclusiveList.splice(index, 1);
            }
        }
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    facilityList(value, push, ifchangeUrl) {
        if (!this.realparams.facilityList) {
            this.realparams.facilityList = [];
        }
        if (push) {
            this.realparams.facilityList.push(value);
        } else {
            const index = this.realparams.facilityList.findIndex((item, i) => {
                return item.code === value.code;
            });
            if (index >= 0) {
                this.realparams.facilityList.splice(index, 1);
            }
        }
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    locatedList(value, push, ifchangeUrl) {
        if (!this.realparams.locatedList) {
            this.realparams.locatedList = [];
        }
        if (push) {
            this.realparams.locatedList.push(value);
        } else {
            const index = this.realparams.locatedList.findIndex((item, i) => {
                return item.code === value.code;
            });
            if (index >= 0) {
                this.realparams.locatedList.splice(index, 1);
            }
        }
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    roomTypeListTotal(value) {
        this.realparams.roomTypeList = value;
    }

    roomTypeList(value, push) {
        if (!this.realparams.roomTypeList) {
            this.realparams.roomTypeList = [];
        }
        if (push) {
            this.realparams.roomTypeList.push(value);
        } else {
            const index = this.realparams.roomTypeList.findIndex((item, i) => {
                return item.code === value.code;
            });
            if (index >= 0) {
                this.realparams.roomTypeList.splice(index, 1);
            }
        }
        this.changeUrl();
    }

    serviceCode(value, push) {
        if (!this.realparams.serviceCode) {
            this.realparams.serviceCode = [];
        }
        if (push) {
            this.realparams.serviceCode.push(value);
        } else {
            const index = this.realparams.serviceCode.findIndex((item, i) => {
                return item.code === value.code;
            });
            if (index >= 0) {
                this.realparams.serviceCode.splice(index, 1);
            }
        }
        this.changeUrl();
    }

    roomIdList(value, push) {
        if (!this.realparams.roomIdList) {
            this.realparams.roomIdList = [];
        }
        if (push) {
            this.realparams.roomIdList.push(value);
        } else {
            const index = this.realparams.roomIdList.findIndex((item, i) => {
                return item.code === value.code;
            });
            if (index >= 0) {
                this.realparams.roomIdList.splice(index, 1);
            }
        }
        this.changeUrl();
    }

    roomIdListOpFaLo(val, isLK?) {
        if (isLK) {
            this.realparams.serviceCode = [val.roomId];
        } else if (val.roomId?.code?.length > 0) {
            this.realparams.roomIdList = [val.roomId];
        }

        if (val.locationCode?.code?.length > 0) {
            this.realparams.locatedList = [val.locationCode];
        }

        if (val.amenityCode?.code?.length > 0) {
            this.realparams.facilityList = [val.amenityCode];
        }

        if (val.tourOperator?.code?.length > 0) {
            this.realparams.tourOperatorList = [val.tourOperator];
        }
        this.changeUrl();
    }

    tourOperatorList(value, push) {
        if (!this.realparams.tourOperatorList) {
            this.realparams.tourOperatorList = [];
        }
        if (push) {
            this.realparams.tourOperatorList.push(value);
        } else {
            const index = this.realparams.tourOperatorList.findIndex((item, i) => {
                return item.code === value.code;
            });
            if (index >= 0) {
                this.realparams.tourOperatorList.splice(index, 1);
            }
        }
        this.changeUrl();
    }

    keywordList(value, push) {
        if (!this.realparams.keywordList) {
            this.realparams.keywordList = [];
        }
        if (push) {
            this.realparams.keywordList.push(value);
        } else {
            const index = this.realparams.keywordList.findIndex((item, i) => {
                return item.code === value.code;
            });
            if (index >= 0) {
                this.realparams.keywordList.splice(index, 1);
            }
        }
        this.changeUrl();
    }

    directness(ev, ifchangeUrl) {
        if (this.realparams.flight) {
            this.realparams.flight.directness = ev;
        } else {
            this.realparams.flight = {
                directness: ev,
            };
        }
        this.realparams.flight.stopover = "";
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    stopover(ev, ifchangeUrl) {
        if (this.realparams.flight) {
            this.realparams.flight.stopover = ev;
        } else {
            this.realparams.flight = {
                stopover: ev,
            };
        }
        this.realparams.flight.directness = "";
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    tarifclass(ev, ifchangeUrl) {
        if (this.realparams.flight) {
            this.realparams.flight.tariff = ev;
        } else {
            this.realparams.flight = {
                tariff: ev,
            };
        }
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    bookingClass(ev, ifchangeUrl) {
        if (this.realparams.flight) {
            this.realparams.flight.bookingClass = ev;
        } else {
            this.realparams.flight = {
                bookingClass: ev,
            };
        }
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    travelClass(ev, ifchangeUrl) {
        if (this.realparams.flight) {
            this.realparams.flight.travelClass = ev;
        } else {
            this.realparams.flight = {
                travelClass: ev,
            };
        }
        if (ifchangeUrl) {
            this.changeUrl();
        }
    }

    roomCatList(value) {
        this.realparams.roomCatList = value;
        this.changeUrl();
    }

    openCurrentHotelInfo(offerObject) {
        this.openHotelInfoWithOperator.next(offerObject);
    }

    setIsReilTravel(israiltravel) {
        this.realparams.israiltravel = israiltravel;
    }

    setReference(reference) {
        this.realparams.reference = reference;
    }

    resetAllExtras() {
        this.realparams.minPricePerPerson = null;
        this.realparams.maxPricePerPerson = null;
        this.realparams.inclusiveListServiceOffer = null;
        this.realparams.minCategory = 0;
        this.realparams.recommendation = null;
        this.realparams.recommendationcount = null;
        this.realparams.zommermitmeerblick = null;
        this.realparams.meerseite = null;
        this.realparams.boardTypeList = null;
        this.realparams.transferlist = null;
        this.realparams.inclusiveList = null;
        this.realparams.facilityList = null;
        this.realparams.roomTypeList = null;
        this.realparams.giataIdList = null;
        this.realparams.regionList = null;
        this.realparams.countryList = null;
        this.realparams.tourOperatorList = null;
        this.realparams.keywordList = null;
        this.realparams.arrivalAirportList = null;
        this.realparams.hotelChainList = null;
        this.realparams.roomCatList = null;
        this.realparams.flight = null;
        this.realparams.mindepartureTime = null;
        this.realparams.maxdepartureTime = null;
        this.realparams.roomIdList = null;
        this.realparams.serviceCode = null;
        this.realparams.locatedList = null;
        this.realparams.flightCarrierList = null;
        this.realparams.minreturnTime = null;
        this.realparams.maxreturnTime = null;
        this.realparams.airportsResult = null;
        this.realparams.hotelCodeList = null;

        this.changeUrl();
    }

    resetAllExtrasHome(): void {
        this.realparams.extra = null;
        this.realparams.bookingcode = null;
        this.realparams.airportsResult = null;
        this.realparams.pauschalreiseResult = null;
        this.realparams.minPricePerPerson = null;
        this.realparams.maxPricePerPerson = null;
        this.realparams.inclusiveListServiceOffer = null;
        this.realparams.minCategory = 0;
        this.realparams.recommendation = null;
        this.realparams.recommendationcount = null;
        this.realparams.zommermitmeerblick = null;
        this.realparams.meerseite = null;
        this.realparams.boardTypeList = null;
        this.realparams.transferlist = null;
        this.realparams.inclusiveList = null;
        this.realparams.facilityList = null;
        this.realparams.roomTypeList = null;
        this.realparams.giataIdList = null;
        this.realparams.regionList = null;
        this.realparams.countryList = null;
        this.realparams.tourOperatorList = null;
        this.realparams.keywordList = null;
        this.realparams.arrivalAirportList = null;
        this.realparams.hotelChainList = null;
        this.realparams.roomCatList = null;
        this.realparams.flight = null;
        this.realparams.maxdepartureTime = null;
        this.realparams.mindepartureTime = null;
        this.realparams.roomIdList = null;
        this.realparams.serviceCode = null;
        this.realparams.locatedList = null;
        this.realparams.flightCarrierList = null;
        this.realparams.maxreturnTime = null;
        this.realparams.minreturnTime = null;
        this.filters.next(this.realparams);
    }

    changeUrl() {
        const url = this.router
            .createUrlTree([], {
                queryParams: { params: this.encservice.encrypt(this.realparams) },
            })
            .toString();
        this.location.replaceState(url);
        this.filters.next(this.realparams);
    }

    changeUrlByType(productType) {
        this.savePauschalreiseToLocal();
        if (productType?.length > 0) {
            this.realparams.productType = productType;
        }
        if (this.realparams?.pauschalreiseResult?.type === 1) {
            this.gotooffers();
        } else {
            // 4 = country
            if (this.realparams?.pauschalreiseResult?.data) {
                this.gotohotels();
            } else {
                this.gototopregions();
            }
        }
    }

    gotoUrl(productType: string) {
        this.savePauschalreiseToLocal();
        if (productType?.length > 0) {
            this.realparams.productType = productType;
        }
        if (this.realparams?.pauschalreiseResult?.type === 1) {
            this.gotooffers();
        } else {
            // 4 = country
            if (this.realparams?.pauschalreiseResult?.data) {
                this.gotohotels();
            } else {
                this.gototopregions();
            }
        }
    }

    savePauschalreiseToLocal(index = null) {
        let existingCache = localStorage.getItem("pauschalreise");

        let arr = [];
        if (existingCache) {
            try {
                arr = JSON.parse(existingCache);
            } catch (e) {
                console.error("Failed to parse localStorage data:", e);
                arr = [];
            }
        }
        for (let i = 0; i < arr.length; i++) {
            if (index == i) {
                arr.splice(index, 1);
                localStorage.setItem("pauschalreise", JSON.stringify(arr));
                return;
            }
            if (
                this.realparams?.pauschalreiseResult?.data?.name ==
                arr[i].pauschalreiseResult?.data?.name &&
                this.realparams?.reisezeitraumResult?.start ==
                arr[i].reisezeitraumResult?.start &&
                this.realparams?.reisezeitraumResult?.end ==
                arr[i].reisezeitraumResult?.end &&
                this.realparams?.reisedauerResult?.name ==
                arr[i].reisedauerResult?.name &&
                this.realparams?.reisendeResult?.adults ==
                arr[i].reisendeResult?.adults &&
                this.realparams?.reisendeResult?.children?.length ==
                arr[i].reisendeResult?.children?.length
            ) {
                return;
            }
        }
        //add recent to the front
        if (this.realparams.pauschalreiseResult?.data?.code) {
            arr.unshift(this.realparams);
        }
        // Keep only the recent 5 entries
        if (arr.length > 5) {
            arr = arr.slice(0, 5);
        }
        localStorage.setItem("pauschalreise", JSON.stringify(arr));
    }

    gotoUrlFlug(productType: string) {
        if (productType?.length > 0) {
            this.realparams.productType = productType;
        }
        if (this.realparams?.arrivalAirportList?.length > 0) {
            this.gotoflugs();
        } else {
            this.gototopregions();
        }
        this.savePauschalreiseToLocal();
    }

    gotooffers() {
        if (this.guardService.getPartnerId()?.length > 0) {
            const url = this.router
                .createUrlTree(["offers"], {
                    queryParams: { params: this.encservice.encrypt(this.realparams) },
                })
                .toString();
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("visibility", "hidden");
            link.click();
        }
        this.savePauschalreiseToLocal();
    }

    gotohotels() {
        if (this.guardService.getPartnerId()?.length > 0) {
            const url = this.router
                .createUrlTree(["hotellist"], {
                    queryParams: { params: this.encservice.encrypt(this.realparams) },
                })
                .toString();
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("visibility", "hidden");
            link.click();
        }
        this.savePauschalreiseToLocal();
    }

    gotoflugs() {
        if (this.guardService.getPartnerId()?.length > 0) {
            const url = this.router
                .createUrlTree(["flugs"], {
                    queryParams: { params: this.encservice.encrypt(this.realparams) },
                })
                .toString();
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("visibility", "hidden");
            link.click();
        }
        this.savePauschalreiseToLocal();
    }

    async gotoPreisAlarm() {
        this.router.navigate(["preisalarm"]);
    }

    gototopregions() {
        if (this.guardService.getPartnerId()?.length > 0) {
            const url = this.router
                .createUrlTree(["topregions"], {
                    queryParams: { params: this.encservice.encrypt(this.realparams) },
                })
                .toString();
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("visibility", "hidden");
            link.click();
        }
        this.savePauschalreiseToLocal();
    }

    setExtraCount(value) {
        this.extrasCount.next(value);
    }

    get extrasCount$(): Observable<number> {
        return this.extrasCount.asObservable();
    }
}
